
<button *ngIf="type != 'certificate'" class="btn btn-primary btn-sm btn-upload-file" type="button" (click)="fileField.click()">
    {{ label }}
    <input 
      class="hide"
      type="file"
      [multiple]="multiple"
      #fileField
      (change)="selectFile($event.target.files)">
</button>

<button *ngIf="type == 'certificate'" class="btn btn-light certificate" type="button" ngbTooltip="{{ 'UPLOAD_FILE' | translate }}" (click)="fileField.click()">
  <input 
      class="hide"
      type="file"
      [multiple]="multiple"
      #fileField
      (change)="selectFile($event.target.files)">
  <svg-icon class="" src="/assets/images/icons/upload.svg" [stretch]="true"></svg-icon>
</button>